import React, { Component }  from 'react';
import * as actions from '../../store/actions/actions';
import Header from './Header'
import Sidebar from './Sidebar'
import Offsidebar from './Offsidebar'
import Footer from './Footer'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


class Base extends Component {
  constructor(props) {
    super(props);
    this.props.actions.changeTheme('themes/theme-a.css');

    //Acabar sesion despues de 15 minutos
    setInterval(() => {
      window.location = '/login';
      //this.props.history.push('/login');
    }, 900000);//1000 un segundo
  }


  render() {

    return (
      <div className="wrapper">
        <Header />

        <Sidebar />

        <Offsidebar />

        <section className="section-container">
          { this.props.children }
        </section>

        <Footer />
      </div>
    );
  }

}


Base.propTypes = {
    actions: PropTypes.object,
    settings: PropTypes.object
};

const mapStateToProps = state => ({ settings: state.settings });
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Base);
